import { render, staticRenderFns } from "./OrderDetailsShipmentItem.vue?vue&type=template&id=3361031e&"
import script from "./OrderDetailsShipmentItem.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsShipmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports